import Page from 'components/Page'
import { TrackCaloriesGetApp } from './GetApp'
import { TrackCaloriesReviews } from './Reviews'
import { TrackCaloriesHowItWorks } from './HowItWorks'
import { TrackCaloriesWhoItsBuiltFor } from './WhoItsBuiltFor'
import React from 'react'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { TrackCaloriesHero } from './Hero/index.js'
import { logEventFacebookPixelUtil } from 'modules/facebook/utils/logEvent/index.js'
import { FACEBOOK_PIXEL_EVENT } from 'modules/facebook/constants/index.js'
import { TrackCaloriesPricing } from 'pages/TrackCalories/Pricing/index.js'
import { TrackCaloriesFAQ } from 'pages/TrackCalories/FAQ/index.js'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { createProfileAction } from 'modules/profile/redux/actions/create/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import { updateInterestFocusProfileAction } from 'modules/profile/redux/actions/updateInterestFocus/index.js'
import { PROFILE_INTEREST_FOCUS } from '@gymaholic/packages'

const dispatch = useDispatch()

const messages = defineMessages({
  title: {
    id: 'TrackCaloriesPages.title',
    defaultMessage: 'Track Calories in Seconds - Gymaholic App'
  }
})

export default function TrackCaloriesPages () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()

  React.useEffect(() => {
    logEventFacebookPixelUtil(FACEBOOK_PIXEL_EVENT.VIEW_CONTENT, {
      content_name: 'Track Calories Page',
      content_category: 'Landing'
    })

    dispatch(createProfileAction())
    dispatch(updateInterestFocusProfileAction(PROFILE_INTEREST_FOCUS.NUTRITION))
  }, [])

  return (
    <Page
      shouldNotHavePadding
      style={{
        textAlign: isSmallScreen
          ? 'center'
          : undefined
      }}
      title={formatMessageIntlUtil(intl, messages.title)}
    >
      <TrackCaloriesHero />
      <TrackCaloriesWhoItsBuiltFor />
      <TrackCaloriesReviews />
      <TrackCaloriesHowItWorks />
      <TrackCaloriesPricing />
      <TrackCaloriesGetApp />
      <TrackCaloriesFAQ />
    </Page>
  )
}
